<template>
  <div class="container mx-auto mt-0 p-2 bg-gray-100 rounded-md shadow-lg w-full max-w-xs sm:max-w-sm">
  <div class="bg-gray-100 p-5 rounded-md">
 


    <h2 class="text-xl sm:text-2xl font-extrabold mb-1">Great News!</h2>
    <p class="text-gray-800 text-sm md:text-base mb-2">
      We'd like to make a cash offer on your property.
      Please enter your details below.
    </p>

    <form id="request-cash-offer" @submit.prevent="submitForm">
<div class="mb-4">
<input
class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline md:py-4 md:px-4 md:text-lg"
  id="firstName"
  type="text"
  v-model="firstName"
  placeholder="First Name"
  @blur="validateFirstName"
/>
<p class="text-red-500 text-xs italic" v-if="firstNameError">{{ firstNameError }}</p>
</div>

<div class="mb-4">
<input
class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline md:py-4 md:px-4 md:text-lg"
  id="lastName"
  type="text"
  v-model="lastName"
  placeholder="Last Name"
  @blur="validateLastName"
/>
<p class="text-red-500 text-xs italic" v-if="lastNameError">{{ lastNameError }}</p>
</div>

<div class="mb-4">
<input
class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline md:py-4 md:px-4 md:text-lg"
  id="email"
  type="text"
  v-model="email"
  placeholder="Email"
  @blur="validateEmail"
/>
<p class="text-red-500 text-xs italic" v-if="emailError">{{ emailError }}</p>
</div>

<div class="mb-4">
<input
class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline md:py-4 md:px-4 md:text-lg"
  id="phone"
  type="tel"
  v-model="phone"
  placeholder="Contact Number"
  @blur="validatePhone"
/>
<p class="block text-xs font-medium text-gray-500 small-device-text">We need a valid number to make an offer</p>
<p class="text-red-500 text-xs italic" v-if="phoneError">{{ phoneError }}</p>
</div>
    <div class="mb-4">
      <label class="inline-flex items-center">
        <input
          type="checkbox"
          class="form-checkbox text-green-500"
          v-model="privacyPolicy"
        />
        <span class="ml-2">I agree to the <a href="/privacy-policy" class="text-blue-500" target="_blank">Privacy Policy</a>.</span>
      </label>
      <p class="text-red-500 text-xs italic" v-if="privacyPolicyError">{{ privacyPolicyError }}</p>
    </div>


    <div class="mb-4">
<div class="flex items-center justify-between">
  <button
    class="border-b-4 border-green-800 mt-2 text-sm sm:text-lg block w-full items-center px-8 py-3 bg-green-600 text-white rounded-2xl font-bold hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
    type="submit">
    GET CASH OFFER NOW→
  </button>
</div>
<!---<p class="mt-4 text-xs text-gray-500">
  By selecting 'Get Cash Offer Now→', you consent to being contacted by us to discuss your property.
</p> -->
</div>

    </form>
    <div class="mt-2 flex justify-center">
      <p class="text-gray-500 flex items-center">
        <i class="text-green-600 fas fa-shield-alt mr-1 text-sm items-center"></i>
        Safe, secure &amp; confidential
      </p>
    </div>
  </div>
</div>
</template>

       
<script>
import axios from "axios";

const dataSoapApiKey = "3c6673da8ed24dadaffd5f7663631f5ed731304b6d24412a9c80384090af46c7"; 


export default {
  props: {
    addressData: {
      type: Object,
      default: () => ({}),
    },
    gclid: {
      type: String,
      default: '',
    },
    quizData: {
      type: Object,
      default: () => ({}),
    },
    utmCampaign: {
      type: String,
      default: '',
    },
    utmSource: {
      type: String,
      default: '',
    },
    utmMedium: {
      type: String,
      default: '',
    },
    utmKeyword: {
      type: String,
      default: '',
    },
    utmDevice: {
      type: String,
      default: '',
    },
    utmMatchType: {
      type: String,
      default: '',
    },
    seoQuery: {
      type: String,
      default: '',
    },
    creativeId: {
      type: String,
      default: '',
    },
  },
  name: "ContactForm",
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      firstNameError: "",
      lastNameError: "",
      emailError: "",
      phoneError: "",
      messageError: "",
      privacyPolicy: false,
      privacyPolicyError: "",
      isSubmitting: false,
      submitSuccess: false,
      submitError: false,
      quizDataMapping: {
        apiParam1: "on_market",
        apiParam2: "prop_type",
        apiParam3: "beds",
        apiParam4: "reasons_for_sale",
        apiParam5: "speed_of_sale",
        phoneHlrStatus: null,
        country: "",
      },
      localUtmCampaign: this.utmCampaign,
      localUtmSource: this.utmSource,
      localUtmMedium: this.utmMedium,
      localUtmKeyword: this.utmKeyword,
      localUtmDevice: this.utmDevice,
      localUtmMatchType: this.utmMatchType,
      localAdId: this.adId,
      localAdSetId: this.adSetId,
      localSeoQuery: this.seoQuery,
      localCreativeId: this.creativeId,
      localGclid: this.gclid,
    };
  },
  created() {
    if (this.localUtmCampaign) {
      localStorage.setItem("utm_campaign", this.localUtmCampaign);
    } else {
      const storedUtmCampaign = localStorage.getItem("utm_campaign");
      if (storedUtmCampaign) {
        this.localUtmCampaign = storedUtmCampaign;
      }
    }

    if (this.localGclid) {
      localStorage.setItem("gclid", this.localGclid);
    } else {
      const storedGclid = localStorage.getItem("gclid");
      if (storedGclid) {
        this.localGclid = storedGclid;
      }
    }

    if (this.localUtmSource) {
      localStorage.setItem("utm_source", this.localUtmSource);
    } else {
      const storedUtmSource = localStorage.getItem("utm_source");
      if (storedUtmSource) {
        this.localUtmSource = storedUtmSource;
      }
    }

    if (this.localUtmMedium) {
      localStorage.setItem("utm_medium", this.localUtmMedium);
    } else {
      const storedUtmMedium = localStorage.getItem("utm_medium");
      if (storedUtmMedium) {
        this.localUtmMedium = storedUtmMedium;
      }
    }

    if (this.localUtmKeyword) {
      localStorage.setItem("utm_keyword", this.localUtmKeyword);
    } else {
      const storedUtmKeyword = localStorage.getItem("utm_keyword");
      if (storedUtmKeyword) {
        this.localUtmKeyword = storedUtmKeyword;
      }
    }

    if (this.localUtmDevice) {
      localStorage.setItem("utm_device", this.localUtmDevice);
    } else {
      const storedUtmDevice = localStorage.getItem("utm_device");
      if (storedUtmDevice) {
        this.localUtmDevice = storedUtmDevice;
      }
    }

    if (this.localUtmMatchType) {
      localStorage.setItem("matchtype", this.localUtmMatchType);
    } else {
      const storedUtmMatchType = localStorage.getItem("matchtype");
      if (storedUtmMatchType) {
        this.localUtmMatchType = storedUtmMatchType;
      }
    }

    if (this.localSeoQuery) {
      localStorage.setItem("seo_query", this.localSeoQuery);
    } else {
      const storedSeoQuery = localStorage.getItem("seo_query");
      if (storedSeoQuery) {
        this.localSeoQuery = storedSeoQuery;
      }
    }

    if (this.localCreativeId) {
      localStorage.setItem("creativeid", this.localCreativeId);
    } else {
      const storedCreativeId = localStorage.getItem("utm_creativeid");
      if (storedCreativeId) {
        this.localCreativeId = storedCreativeId;
      }
    }
  },
  methods: {
    validateFirstName() {
      if (!this.firstName) {
        this.firstNameError = "First name is required";
      } else {
        this.firstNameError = "";
      }
    },
    validateLastName() {
      if (!this.lastName) {
        this.lastNameError = "Last name is required";
      } else {
        this.lastNameError = "";
      }
    },

    validateEmail() {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!this.email) {
        this.emailError = "Email is required";
      } else if (!emailPattern.test(this.email)) {
        this.emailError = "Invalid email address";
      } else {
        this.emailError = "";
      }
    },

    async validatePhone() {
      const phonePattern = /^(\+?\d{1,4}[-\s]?)?(\d{1,4}[-\s]?){1,7}\d{1,4}$/;
      if (!this.phone) {
        this.phoneError = "Phone number is required";
      } else if (!phonePattern.test(this.phone)) {
        this.phoneError = "Invalid phone number";
      } else {
        try {
          const isValid = await this.validateMobileNumberWithDatasoap();
          if (isValid === false) {
            this.phoneError = "Invalid mobile number";
          } else {
            this.phoneError = "";
          }
        } catch (error) {
          console.error("Error validating mobile number with DataSoap:", error);
          this.phoneError = "";
        }
      }
    },

    validatePrivacyPolicy() {
      if (!this.privacyPolicy) {
        this.privacyPolicyError = "You must agree to the Privacy Policy";
      } else {
        this.privacyPolicyError = "";
      }
    },

    async validateMobileNumberWithDatasoap() {
      try {
        const response = await axios.post(
          'https://api.datasoap.co.uk/v2',
          {
            lookup: this.phone,
            checks: ['hlr']
          },
          {
            headers: {
              'Content-Type': 'application/json-patch+json',
              'accept': 'text/plain',
              'Authorization': `Bearer ${dataSoapApiKey}`
            }
          }
        );
        console.log("DataSoap API response:", response.data);

        if (response.data.valid === true) {
          this.phoneHlrStatus = response.data.hlr.on ? 'active' : 'non-active';
          this.phoneError = "";
          return true;
        } else {
          this.phoneError = 'Invalid mobile number';
          return false;
        }
      } catch (error) {
        console.error('Error validating mobile number with DataSoap:', error);
        const phonePattern = /^(\+?\d{1,4}[-\s]?)?(\d{1,4}[-\s]?){1,7}\d{1,4}$/;
        if (!this.phone || !phonePattern.test(this.phone)) {
          this.phoneError = "Invalid phone number";
          return false;
        } else {
          this.phoneError = "";
          return true;
        }
      }
    },

    async submitForm() {
      this.validateFirstName();
      this.validateLastName();
      this.validateEmail();
      await this.validatePhone();
      this.validatePrivacyPolicy();

      if (this.firstNameError || this.lastNameError || this.emailError || (this.phoneError !== null && this.phoneError !== undefined && this.phoneError !== '') || this.privacyPolicyError) {
        return;
      }

      this.isSubmitting = true;

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      try {
        const payload = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          phone: this.phone,
          utm_source: this.localUtmSource || "",
          utm_medium: this.localUtmMedium || "",
          utm_campaign: this.localUtmCampaign || "",
          utm_term: "",
          utm_content: "",
          utm_keyword: this.localUtmKeyword || "",
          sale_importance: "",
          source: "",
          seo_url: this.localSeoQuery || "",
          page_variant: "",
          type: "",
          formtype: "",
          below_market: "",
          approx_cash_offer_: "",
          moveout_: "",
          country: this.addressData?.country || "",
          reasons_for_sale: this.quizData?.apiParam4 || "",
          phone_hlr: this.phoneHlrStatus || "",
          address: this.addressData?.street || "",
          postcode: this.addressData?.postcode || "",
          beds: this.quizData?.apiParam3 || "",
          gclid: this.localGclid || "",
          prop_type: this.quizData?.apiParam2 || "",
          property_condition: "",
          accepted_terms: this.privacyPolicy ? "1" : "0",
          utm_matchtype: this.localUtmMatchType || "",
          utm_device: this.localUtmDevice || "",
          on_market: this.quizData?.apiParam1 || "",
          speed_of_sale: this.quizData?.apiParam5 || "",
        };

        console.log("Submitting payload to new endpoint:", payload);

        await axios.post(
          "https://app.leadseeker.co/api/affiliate-form/6_10_ml48ql3z4t1kol",
          payload,
          config
        );

        this.submitSuccess = true;
        this.submitError = false;
      } catch (error) {
        this.submitSuccess = false;
        this.submitError = true;
        console.error("Error posting the form:", error);
      }

      this.isSubmitting = false;

      if (this.submitSuccess) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'leadSubmission',
          'lead_score': this.leadScore,
          'email': this.email,
          'gclid': this.gclid,
        });

        localStorage.setItem('userEmail', this.email);
        window.location.href = `/thank-you?email=${encodeURIComponent(this.email)}`;
      }
    },
  },
  computed: {
    isFormValid() {
      return (
        this.firstName &&
        this.lastName &&
        this.email &&
        this.phone &&
        this.privacyPolicy
      );
    },
  },
};
</script>

<style>
@media (max-width: 640px) {
.small-device-text {
  font-size: 0.525rem; /* Adjust the value to your preference */
}
}
</style>
